import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import api from '../../services/api';
import { fetchUserDetails, saveTokens, removeTokens } from '../../services/authService';
import ScreenLoader from '../HtmlElements/ScreenLoader';

export default function VerifyToken() {

    const { token } = useParams();
    const [loader, setLoader] = useState(false);

    const verifyMyToken = useCallback(async () => {
        setLoader(true);
        try {
          
            // const response = await api.post('/auth/login', { email: 'bhatu.pawar@marketsandmarkets.com', password: 'password123' });
            removeTokens();
            const response =  await api.post('/auth/verify_token', { token });
            const { access_token, refresh_token } = response.data.result;
            if(access_token && refresh_token){
                saveTokens(access_token, refresh_token);
                let userInfo = await fetchUserDetails();
                let current_role_key = userInfo?.role_key;

                if(current_role_key === 'CLIENT'){
                    userInfo.is_onboarded = 1;
                    if(userInfo?.is_onboarded == null || userInfo?.is_onboarded === 0){
                      // navigate('/user_profile/profile');
                      window.location.replace('/user_profile/profile');
                    }else{
                      // navigate('/dashboard');
                      window.location.replace('/dashboard');
                    }
                  }else{
                    window.location.replace("/users");
                  }

                return true;
            }else{
                return false;
            }

          // console.log(response.data.result.list);
          // setAccounts(response.data.result.list);
          // setTotalPages(Math.ceil(response.data.result.total / perPage));
        } catch (err) {
          // setError(err.message || 'Failed to fetch Accounts');
        }
        setLoader(false);
      }, [token]);

    useEffect(() => {
        // let successMessage = sessionStorage.getItem('successMessage');
        // if (successMessage) {
        //   setSuccessMessage(successMessage);
        //   sessionStorage.removeItem('successMessage'); // Clear the message
        // }
        verifyMyToken();
    }, [verifyMyToken]);


    console.log(token)

    return (
        <div>
            {loader && <ScreenLoader />}
        </div>
    )
}
